<template>
  <div class="">
    <v-row class="pa-3" justify="end">
      <v-btn
        color=kazan
        outlined
        @click="gotoCreate()"
        v-if="isManaged"
      >
        <v-icon>add</v-icon>
        {{$t('buttons.add_new')}}
      </v-btn>
    </v-row>
    <VehicleListItem
      v-for="(vehicle, index) in vehicles"
      :vehicle="vehicle"
      :key="index"
      :companyID="companyID"
    />
  </div>
</template>

<script>
import router from '@/router'
import VehicleListItem from '@/components/fleet/VehicleListItem'

export default {
  name: 'VehicleList',
  components: {
    VehicleListItem
  },
  props: {
    vehicles: Array,
    companyID: String,
    isManaged: Boolean
  },
  data () {
    return {}
  },
  computed: {},
  methods: {
    gotoCreate () {
      router.push({ name: 'CreateVehicle' })
    }
  },
  created () {}
}
</script>

<style lang="scss" scoped>

</style>
